<script>
  import { _ } from "./i18n.js";
  import { f7, App, View } from "framework7-svelte";
  import routes from "./routes.js";
  import { getSecuredFirestore } from "./Firestore.js";
  import { getProfile } from "./UserService.js";

  getProfile().then(function(profile) {
    if (!profile.welcomescreenSeen) {
      f7.welcomescreen.open();
    }
  });

  var welcomescreen_slides = [
    {
      id: "welcome",
      title: $_("welcomescreen.title"),
      picture:
        '<div><img style="opacity: 1; max-width: 250px; width: 100%;" src="/logo.png"/></div>',
      text: $_("welcomescreen.bylocals")
    },
    {
      id: "carryBottles",
      title: $_("about.noCarryBottles"),
      picture:
        '<div><span style="font-size: 8rem;" class="icon icon-pain" /></div>',
      text: $_("welcomescreen.bylocals")
    },
    {
      id: "within90Min",
      title: $_("about.within90min"),
      picture:
        '<div><span style="font-size: 8rem;" class="icon icon-delivery" /></div>',
      text: $_("welcomescreen.bylocals")
    },
    {
      id: "quality",
      title: $_("about.waterQuality")
        .split(": ")
        .join("<br>"),
      picture:
        '<div><span style="font-size: 8rem;" class="icon icon-quality" /></div>',
      text: $_("welcomescreen.bylocals")
    }
  ];

  const f7params = {
    theme: "auto",
    routes,
    name: "Tueyhom Delivery",
    id: "com.seaeagletour.tueyhom.svelte",
    root: "#app",
    dialog: {
      buttonOk: $_("base.ok"),
      buttonCancel: $_("base.cancel")
    },
    navbar: {
      hideOnPageScroll: true,
      showOnPageScrollEnd: false
    },
    on: {
      init: function() {
        let splashNode = document.getElementById("splash");
        if (splashNode != null) {
          splashNode.classList.add("hidden");
          document.getElementById("framework7-root").classList.add("visible");
          setTimeout(function() {
            splashNode.remove();
          }, 400);
        }
      },
      pageAfterOut: function(page) {
        f7.smartSelect.close();
        f7.sheet.close();
      },
      pageAfterIn: function(page) {
        let currentRoute = page.route.route;
        let title =
          currentRoute.tab && currentRoute.tab.title
            ? currentRoute.tab.title
            : currentRoute.title
            ? currentRoute.title
            : null;

        if (title) {
          document.title = $_(title) + " - Tueyhom Delivery";
        } else {
          document.title = "Tueyhom Delivery";
        }
      }
    },
    welcomescreen: {
      slides: welcomescreen_slides,
      options: {
        bgcolor: "#0da6ec",
        fontcolor: "#fff",
        open: false,
        closeButtonText: $_("welcomescreen.skip"),
        onClosed: function() {
          getProfile().then(function(profile) {
            getSecuredFirestore().then(function(firestore) {
              firestore
                .collection("users")
                .doc(profile.userId)
                .update({ welcomescreenSeen: true });
            });
          });
        },
        parallax: true,
        parallaxBackgroundImage: "/welcomescreen.jpg"
      }
    }
  };
</script>

<App params={f7params}>
  <View
    url="/"
    pushState={true}
    history={true}
    pushStateSeparator=""
    main={true} />
</App>
